// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import AccountSettingsState from "@store/Framework/Store/Greif/Pages/AccountSettings/AccountSettingsState";
import { Draft } from "immer";

const initialState: AccountSettingsState = {
    language: "",
};

const actions = {
    "Greif/Pages/AccountSettings/SetAdditionalAccountSettingsValues": (
        draft: Draft<AccountSettingsState>,
        action: AccountSettingsState,
    ) => {
        draft.followNewPrice = action.followNewPrice;
        draft.followNewFeature = action.followNewFeature;
        draft.followNewTec = action.followNewTec;
        draft.followUpcomingShipment = action.followUpcomingShipment;
        draft.followOrderShipped = action.followOrderShipped;
        draft.followOrderPickup = action.followOrderPickup;
        draft.followOrderChange = action.followOrderChange;

        if (action.language) {
            draft.language = action.language;
        }
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifAccountSettingsPageReducer = Parameters<typeof reducer>[1];
export default reducer;
